import React, { FC } from 'react';
import { Container } from './styles';
import { Props } from './types';

const RawInput: FC<Props> = ({ autocomplete, id, ...rest }) => (
  <Container autoComplete={autocomplete} id={id} {...rest} />
);

export default RawInput;
